module.exports = __webpack_public_path__ + "media/images/logo-0c3ce4109ae8cb72f18e2d4d62b9ac37.png";